<template>
    <div class="" style="width: 100%">
        <div id="preview">
            <draggable v-model="images" @end="onEnd" handle=".sort-handler">
                <transition-group>
                    <div
                        class="preview-item"
                        v-for="(img, index) in images"
                        :key="img"
                    >
                        <img class="preview-img" :src="img.url" />
                        <div class="preview-right">
                            <div class="preview-name">
                                {{ img.name }}
                            </div>
                            <div class="preview-controls">
                                <div
                                    class="p-control"
                                    @click="deleteImage(index)"
                                >
                                    <img src="/img/icons/trash.svg" />Löschen
                                </div>
                                <div class="p-control sort-handler">
                                    <img src="/img/icons/reorder.svg" />
                                    Sortieren
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <!-- <div class="preview-item" v-for="(img, index) in images" :key="img.id">
        <img class="preview-img" :src="img.url" />
        <div class="preview-right">
          <div class="preview-name">
            {{ img.name }}
          </div>
          <div class="preview-controls">
            <div class="" @click="deleteImage(index)">Löschen</div>
            <div class="">Sortieren</div>
          </div>
        </div>
      </div> -->
        </div>

        <div class="maxImages" v-if="images.length >= maxImages">
            Du hast die maximale Bilderanzahl erreicht.
        </div>
        <label
            for="imageupload"
            class="image-zone"
            v-if="images.length < maxImages"
            ><img src="/img/icons/add.svg" />
            Bild hinzufügen
        </label>
        <input
            id="imageupload"
            accept="image/*"
            type="file"
            @change="onFileChange"
            multiple
        />

        <div class="error-message">
            {{ errorMessage }}
        </div>

        <ul class="image-disclaimer">
            <li>Maximale zugelassene Bildgröße für den Upload: 500kB</li>
            <li>
                Laden Sie nur Lizenzfreie Bilder / Bilder von denen Sie der
                Urheber sind hoch
            </li>
        </ul>
    </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    props: ["value"],
    data() {
        return {
            images: [],
            maxImages: 6,
            errorMessage: ""
        };
    },
    methods: {
        deleteImage(index) {
            this.images.splice(index, 1);
        },

        sendImage(file) {
            return new Promise((resolve, recject) => {
                let formData = new FormData();
                formData.append("file", file);
                axios
                    .post("/image", formData)
                    .then(res => {
                        //console.log("RESSSSSS", res);
                        resolve(res.data);
                    })
                    .catch(error => {});
            });
        },
        onEnd() {
            this.$emit("input", this.images);
        },
        onFileChange(e) {
            this.errorMessage = "";
            if (this.images.length < this.maxImages) {
                //console.log("e", file);
                const file = e.target.files[0];
                this.url = URL.createObjectURL(file);
                //console.log("fileinfo", file);
                if (file.size < 600000) {
                    this.sendImage(file).then(res => {
                        //console.log(res);
                        this.images.push({
                            info: res,
                            url: URL.createObjectURL(file),
                            name: file.name
                        });
                        this.$emit("input", this.images);
                    });
                } else {
                    this.errorMessage =
                        "Das Bild darf nicht größer als 500kB sein.";
                }
            }
        }
    },
    mounted() {},
    computed: {}
};
</script>

<style></style>
